export { default } from "~/components/product/ProductShelf";

export const sync = true;

export const cache = "listing";
